import {
	requestWithAbort,
	type ServiceRequestWithAbort,
} from '@atlassian/teams-common/use-service';

export const URL_JIRA_CHECK = '/gateway/api/permissions/permitted';

export const jiraCheckRequestBody = (cloudId: string) => ({
	permissionId: 'write',
	resourceId: `ari:cloud:jira-software::site/${cloudId}`,
});

export const defaultRequestAbort = (cloudId?: string): ReturnType<ServiceRequestWithAbort> =>
	cloudId
		? requestWithAbort(URL_JIRA_CHECK, {
				body: JSON.stringify(jiraCheckRequestBody(cloudId)),
			})
		: [() => Promise.resolve(new Response()), new AbortController()];
